// extracted by mini-css-extract-plugin
export default {"file":"SendFiles_file__6xm7I","fileInner":"SendFiles_fileInner__1tsY3","fileLabel":"SendFiles_fileLabel__vd3Ou","fileButton":"SendFiles_fileButton__BilrV"};